import { useEffect } from "react";
import "@/landing.css";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { PainStats } from "@/components/landing/PainStats";
import { ValueSection } from "@/components/landing/ValueSection";
import { SavingsCalculator } from "@/components/landing/SavingsCalculator";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { WhoItsFor } from "@/components/landing/WhoItsFor";
import { FAQ } from "@/components/landing/FAQ";
import { DemoSection } from "@/components/landing/DemoSection";
import { Footer } from "@/components/landing/Footer";

const useReveal = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".cd-reveal");
    if (!("IntersectionObserver" in window)) { els.forEach((el) => el.classList.add("in")); return undefined; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
    }), { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
};

export default function Landing() {
  useReveal();
  useEffect(() => {
    const prev = document.body.style.background;
    document.body.style.background = "#f5f5ee";
    return () => { document.body.style.background = prev; };
  }, []);
  return (
    <div className="cd-page min-h-screen bg-[#f5f5ee] text-[#292929]" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <PainStats />
        <ValueSection />
        <SavingsCalculator />
        <HowItWorks />
        <WhoItsFor />
        <FAQ />
        <DemoSection />
      </main>
      <Footer />
    </div>
  );
}
